import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { gateway } from 'libs/generated-grpc-web';

@Component({
  selector: 'mg-event-notification',
  templateUrl: './MgEventNotification.element.html',
  styleUrls: ['./MgEventNotification.element.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MgEventNotificationElement {
  @Input()
  notification?: gateway.notification_pb.Notification.AsObject;
}
